import { CullMode } from "../../../RenderEngine/RenderEnum/CullMode";
import { GLSLCodeGenerator } from "../../../RenderEngine/RenderShader/GLSLCodeGenerator";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { CommandEncoder } from "../../../layagl/CommandEncoder";
import { LayaGL } from "../../../layagl/LayaGL";
import { RenderState } from "../../RenderModuleData/Design/RenderState";
import { WebGLEngine } from "./WebGLEngine";
import { Config } from "../../../../Config";
import { WebGLRenderContext3D } from "../3DRenderPass/WebGLRenderContext3D";
export class WebGLShaderInstance {
    constructor() {
        this._cacheShaerVariable = {};
        this._uploadMark = -1;
        this._uploadRenderType = -1;
        this._additionUniformParamsMaps = new Map();
        this._additionShaderData = new Map();
    }
    _serializeShader() {
        return null;
    }
    _deserialize(buffer) {
        return false;
    }
    get complete() {
        return this._renderShaderInstance._complete;
    }
    _create(shaderProcessInfo, shaderPass) {
        let useMaterial = Config.matUseUBO;
        Config.matUseUBO = (!shaderProcessInfo.is2D) && Config.matUseUBO;
        let shaderObj = GLSLCodeGenerator.GLShaderLanguageProcess3D(shaderProcessInfo.defineString, shaderProcessInfo.attributeMap, shaderProcessInfo.uniformMap, shaderProcessInfo.vs, shaderProcessInfo.ps);
        this._renderShaderInstance = WebGLEngine.instance.createShaderInstance(shaderObj.vs, shaderObj.fs, shaderProcessInfo.attributeMap);
        Config.matUseUBO = useMaterial;
        if (WebGLEngine._lastShaderError) {
            console.warn(`[ShaderCompile]Error compiling shader '${shaderPass._owner._owner.name}' (pipelineMode=${shaderPass.pipelineMode})\n`, WebGLEngine._lastShaderError);
        }
        if (this._renderShaderInstance._complete) {
            this._shaderPass = shaderPass.moduleData;
            shaderProcessInfo.is2D ? this._create2D() : this._create3D();
        }
    }
    _create3D() {
        this._sceneUniformParamsMap = new CommandEncoder();
        this._cameraUniformParamsMap = new CommandEncoder();
        this._spriteUniformParamsMap = new CommandEncoder();
        this._materialUniformParamsMap = new CommandEncoder();
        let context = WebGLRenderContext3D._instance;
        let preDrawUniforms = context._preDrawUniformMaps;
        let preDrawParams = [];
        for (let key of preDrawUniforms) {
            let params = LayaGL.renderDeviceFactory.createGlobalUniformMap(key);
            preDrawParams.push(params);
        }
        const cameraParams = LayaGL.renderDeviceFactory.createGlobalUniformMap("BaseCamera");
        let i, n;
        let data = this._renderShaderInstance.getUniformMap();
        for (i = 0, n = data.length; i < n; i++) {
            let one = data[i];
            if (preDrawParams.find((params) => {
                return params.hasPtrID(one.dataOffset);
            })) {
                this._sceneUniformParamsMap.addShaderUniform(one);
            }
            else if (cameraParams.hasPtrID(one.dataOffset)) {
                this._cameraUniformParamsMap.addShaderUniform(one);
            }
            else if (this.hasSpritePtrID(one.dataOffset)) {
                this._spriteUniformParamsMap.addShaderUniform(one);
            }
            else if (this._hasAdditionShaderData(one.dataOffset)) {
                let str = this._hasAdditionShaderData(one.dataOffset);
                if (!this._additionUniformParamsMaps.get(str)) {
                    let commandEncoder = new CommandEncoder();
                    this._additionUniformParamsMaps.set(str, commandEncoder);
                }
                this._additionUniformParamsMaps.get(str).addShaderUniform(one);
            }
            else {
                this._materialUniformParamsMap.addShaderUniform(one);
            }
        }
    }
    _create2D() {
        this._sprite2DUniformParamsMap = new CommandEncoder();
        this._materialUniformParamsMap = new CommandEncoder();
        this._sceneUniformParamsMap = new CommandEncoder();
        this._cameraUniformParamsMap = new CommandEncoder();
        const passParms = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DPass");
        const globalParams = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DGlobal");
        let i, n;
        let data = this._renderShaderInstance.getUniformMap();
        for (i = 0, n = data.length; i < n; i++) {
            let one = data[i];
            if (this.hasSpritePtrID(one.dataOffset)) {
                this._sprite2DUniformParamsMap.addShaderUniform(one);
            }
            else if (passParms.hasPtrID(one.dataOffset)) {
                this._sceneUniformParamsMap.addShaderUniform(one);
            }
            else if (globalParams.hasPtrID(one.dataOffset)) {
                this._cameraUniformParamsMap.addShaderUniform(one);
            }
            else if (this._hasAdditionShaderData(one.dataOffset)) {
                let str = this._hasAdditionShaderData(one.dataOffset);
                if (!this._additionUniformParamsMaps.get(str)) {
                    let commandEncoder = new CommandEncoder();
                    this._additionUniformParamsMaps.set(str, commandEncoder);
                }
                this._additionUniformParamsMaps.get(str).addShaderUniform(one);
            }
            else {
                this._materialUniformParamsMap.addShaderUniform(one);
            }
        }
    }
    hasSpritePtrID(dataOffset) {
        let commap = this._shaderPass.nodeCommonMap;
        if (!commap) {
            return false;
        }
        else {
            for (let i = 0, n = commap.length; i < n; i++) {
                if (LayaGL.renderDeviceFactory.createGlobalUniformMap(commap[i]).hasPtrID(dataOffset))
                    return true;
            }
            return false;
        }
    }
    _hasAdditionShaderData(dataOffset) {
        let additionShaderData = this._shaderPass.additionShaderData;
        if (!additionShaderData) {
            return null;
        }
        else {
            for (let i = 0, n = additionShaderData.length; i < n; i++) {
                if (LayaGL.renderDeviceFactory.createGlobalUniformMap(additionShaderData[i]).hasPtrID(dataOffset))
                    return additionShaderData[i];
            }
        }
        return null;
    }
    _disposeResource() {
        this._renderShaderInstance.destroy();
        this._sceneUniformParamsMap = null;
        this._cameraUniformParamsMap = null;
        this._spriteUniformParamsMap = null;
        this._materialUniformParamsMap = null;
        this._sprite2DUniformParamsMap = null;
        this._uploadMaterial = null;
        this._uploadRender = null;
        this._uploadCameraShaderValue = null;
        this._uploadScene = null;
        this._additionShaderData = null;
    }
    bind() {
        return this._renderShaderInstance.bind();
    }
    uploadUniforms(shaderUniform, shaderDatas, uploadUnTexture) {
        WebGLEngine.instance.uploadUniforms(this._renderShaderInstance, shaderUniform, shaderDatas, uploadUnTexture);
    }
    uploadRenderStateBlendDepth(shaderDatas) {
        if ((this._shaderPass).statefirst)
            this.uploadRenderStateBlendDepthByShader(shaderDatas);
        else
            this.uploadRenderStateBlendDepthByMaterial(shaderDatas);
    }
    uploadRenderStateBlendDepthByShader(shaderDatas) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
        const engineRenderState = WebGLEngine.instance._GLRenderState;
        var datas = shaderDatas._data;
        var renderState = (this._shaderPass).renderState;
        var depthWrite = (_b = ((_a = renderState.depthWrite) !== null && _a !== void 0 ? _a : datas[Shader3D.DEPTH_WRITE])) !== null && _b !== void 0 ? _b : RenderState.Default.depthWrite;
        engineRenderState.setDepthMask(depthWrite);
        var depthTest = (_d = ((_c = renderState.depthTest) !== null && _c !== void 0 ? _c : datas[Shader3D.DEPTH_TEST])) !== null && _d !== void 0 ? _d : RenderState.Default.depthTest;
        if (depthTest == RenderState.DEPTHTEST_OFF)
            engineRenderState.setDepthTest(false);
        else {
            engineRenderState.setDepthTest(true);
            engineRenderState.setDepthFunc(depthTest);
        }
        var stencilWrite = (_f = ((_e = renderState.stencilWrite) !== null && _e !== void 0 ? _e : datas[Shader3D.STENCIL_WRITE])) !== null && _f !== void 0 ? _f : RenderState.Default.stencilWrite;
        engineRenderState.setStencilWrite(stencilWrite);
        let stencilWriteMask = stencilWrite ? ((_h = ((_g = renderState.stencilWriteMask) !== null && _g !== void 0 ? _g : datas[Shader3D.STENCIL_WRITE_MASK])) !== null && _h !== void 0 ? _h : RenderState.Default.stencilWriteMask) : 0x00;
        engineRenderState.setStencilWriteMask(stencilWriteMask);
        if (stencilWrite) {
            var stencilOp = (_k = ((_j = renderState.stencilOp) !== null && _j !== void 0 ? _j : datas[Shader3D.STENCIL_Op])) !== null && _k !== void 0 ? _k : RenderState.Default.stencilOp;
            engineRenderState.setstencilOp(stencilOp.x, stencilOp.y, stencilOp.z);
        }
        var stencilTest = (_m = ((_l = renderState.stencilTest) !== null && _l !== void 0 ? _l : datas[Shader3D.STENCIL_TEST])) !== null && _m !== void 0 ? _m : RenderState.Default.stencilTest;
        if (stencilTest == RenderState.STENCILTEST_OFF) {
            engineRenderState.setStencilTest(false);
        }
        else {
            engineRenderState.setStencilTest(true);
            var stencilRef = (_p = ((_o = renderState.stencilRef) !== null && _o !== void 0 ? _o : datas[Shader3D.STENCIL_Ref])) !== null && _p !== void 0 ? _p : RenderState.Default.stencilRef;
            let stencilReadMask = (_r = ((_q = renderState.stencilReadMask) !== null && _q !== void 0 ? _q : datas[Shader3D.STENCIL_READ_MASK])) !== null && _r !== void 0 ? _r : RenderState.Default.stencilReadMask;
            engineRenderState.setStencilFunc(stencilTest, stencilRef, stencilReadMask);
        }
        let depthBias = (_t = (_s = renderState.depthBias) !== null && _s !== void 0 ? _s : datas[Shader3D.DEPTH_BIAS]) !== null && _t !== void 0 ? _t : RenderState.Default.depthBias;
        engineRenderState.setDepthBias(depthBias);
        if (depthBias) {
            let depthBiasConstant = (_v = ((_u = renderState.depthBiasConstant) !== null && _u !== void 0 ? _u : datas[Shader3D.DEPTH_BIAS_CONSTANT])) !== null && _v !== void 0 ? _v : RenderState.Default.depthBiasConstant;
            let depthBiasSlopeScale = (_x = ((_w = renderState.depthBiasSlopeScale) !== null && _w !== void 0 ? _w : datas[Shader3D.DEPTH_BIAS_SLOPESCALE])) !== null && _x !== void 0 ? _x : RenderState.Default.depthBiasSlopeScale;
            let depthBiasClamp = (_z = ((_y = renderState.depthBiasClamp) !== null && _y !== void 0 ? _y : datas[Shader3D.DEPTH_BIAS_CLAMP])) !== null && _z !== void 0 ? _z : RenderState.Default.depthBiasClamp;
            engineRenderState.setDepthBiasFactor(depthBiasConstant, depthBiasSlopeScale, depthBiasClamp);
        }
        var blend = (_1 = ((_0 = renderState.blend) !== null && _0 !== void 0 ? _0 : datas[Shader3D.BLEND])) !== null && _1 !== void 0 ? _1 : RenderState.Default.blend;
        switch (blend) {
            case RenderState.BLEND_DISABLE:
                engineRenderState.setBlend(false);
                break;
            case RenderState.BLEND_ENABLE_ALL:
                var blendEquation = (_3 = ((_2 = renderState.blendEquation) !== null && _2 !== void 0 ? _2 : datas[Shader3D.BLEND_EQUATION])) !== null && _3 !== void 0 ? _3 : RenderState.Default.blendEquation;
                var srcBlend = (_5 = ((_4 = renderState.srcBlend) !== null && _4 !== void 0 ? _4 : datas[Shader3D.BLEND_SRC])) !== null && _5 !== void 0 ? _5 : RenderState.Default.srcBlend;
                var dstBlend = (_7 = ((_6 = renderState.dstBlend) !== null && _6 !== void 0 ? _6 : datas[Shader3D.BLEND_DST])) !== null && _7 !== void 0 ? _7 : RenderState.Default.dstBlend;
                engineRenderState.setBlend(true);
                engineRenderState.setBlendEquation(blendEquation);
                engineRenderState.setBlendFunc(srcBlend, dstBlend);
                break;
            case RenderState.BLEND_ENABLE_SEPERATE:
                var blendEquationRGB = (_9 = ((_8 = renderState.blendEquationRGB) !== null && _8 !== void 0 ? _8 : datas[Shader3D.BLEND_EQUATION_RGB])) !== null && _9 !== void 0 ? _9 : RenderState.Default.blendEquationRGB;
                var blendEquationAlpha = (_11 = ((_10 = renderState.blendEquationAlpha) !== null && _10 !== void 0 ? _10 : datas[Shader3D.BLEND_EQUATION_ALPHA])) !== null && _11 !== void 0 ? _11 : RenderState.Default.blendEquationAlpha;
                var srcRGB = (_13 = ((_12 = renderState.srcBlendRGB) !== null && _12 !== void 0 ? _12 : datas[Shader3D.BLEND_SRC_RGB])) !== null && _13 !== void 0 ? _13 : RenderState.Default.srcBlendRGB;
                var dstRGB = (_15 = ((_14 = renderState.dstBlendRGB) !== null && _14 !== void 0 ? _14 : datas[Shader3D.BLEND_DST_RGB])) !== null && _15 !== void 0 ? _15 : RenderState.Default.dstBlendRGB;
                var srcAlpha = (_17 = ((_16 = renderState.srcBlendAlpha) !== null && _16 !== void 0 ? _16 : datas[Shader3D.BLEND_SRC_ALPHA])) !== null && _17 !== void 0 ? _17 : RenderState.Default.srcBlendAlpha;
                var dstAlpha = (_19 = ((_18 = renderState.dstBlendAlpha) !== null && _18 !== void 0 ? _18 : datas[Shader3D.BLEND_DST_ALPHA])) !== null && _19 !== void 0 ? _19 : RenderState.Default.dstBlendAlpha;
                engineRenderState.setBlend(true);
                engineRenderState.setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha);
                engineRenderState.setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                break;
        }
    }
    uploadRenderStateBlendDepthByMaterial(shaderDatas) {
        var _a, _b, _c;
        const engineRenderState = WebGLEngine.instance._GLRenderState;
        var datas = shaderDatas.getData();
        var depthWrite = datas[Shader3D.DEPTH_WRITE];
        depthWrite = depthWrite !== null && depthWrite !== void 0 ? depthWrite : RenderState.Default.depthWrite;
        engineRenderState.setDepthMask(depthWrite);
        var depthTest = datas[Shader3D.DEPTH_TEST];
        depthTest = depthTest !== null && depthTest !== void 0 ? depthTest : RenderState.Default.depthTest;
        if (depthTest === RenderState.DEPTHTEST_OFF) {
            engineRenderState.setDepthTest(false);
        }
        else {
            engineRenderState.setDepthTest(true);
            engineRenderState.setDepthFunc(depthTest);
        }
        var stencilWrite = datas[Shader3D.STENCIL_WRITE];
        stencilWrite = stencilWrite !== null && stencilWrite !== void 0 ? stencilWrite : RenderState.Default.stencilWrite;
        engineRenderState.setStencilWrite(stencilWrite);
        let stencilWriteMask = stencilWrite ? ((_a = datas[Shader3D.STENCIL_WRITE_MASK]) !== null && _a !== void 0 ? _a : RenderState.Default.stencilWriteMask) : 0x00;
        engineRenderState.setStencilWriteMask(stencilWriteMask);
        if (stencilWrite) {
            var stencilOp = datas[Shader3D.STENCIL_Op];
            stencilOp = stencilOp !== null && stencilOp !== void 0 ? stencilOp : RenderState.Default.stencilOp;
            engineRenderState.setstencilOp(stencilOp.x, stencilOp.y, stencilOp.z);
        }
        var stencilTest = datas[Shader3D.STENCIL_TEST];
        stencilTest = stencilTest !== null && stencilTest !== void 0 ? stencilTest : RenderState.Default.stencilTest;
        if (stencilTest == RenderState.STENCILTEST_OFF) {
            engineRenderState.setStencilTest(false);
        }
        else {
            let stencilReadMask = (_b = datas[Shader3D.STENCIL_READ_MASK]) !== null && _b !== void 0 ? _b : RenderState.Default.stencilReadMask;
            var stencilRef = datas[Shader3D.STENCIL_Ref];
            stencilRef = stencilRef !== null && stencilRef !== void 0 ? stencilRef : RenderState.Default.stencilRef;
            engineRenderState.setStencilTest(true);
            engineRenderState.setStencilFunc(stencilTest, stencilRef, stencilReadMask);
        }
        let depthBias = (_c = datas[Shader3D.DEPTH_BIAS]) !== null && _c !== void 0 ? _c : RenderState.Default.depthBias;
        engineRenderState.setDepthBias(depthBias);
        if (depthBias) {
            let depthBiasConstant = datas[Shader3D.DEPTH_BIAS_CONSTANT];
            depthBiasConstant = depthBiasConstant !== null && depthBiasConstant !== void 0 ? depthBiasConstant : RenderState.Default.depthBiasConstant;
            let depthBiasSlopeScale = datas[Shader3D.DEPTH_BIAS_SLOPESCALE];
            depthBiasSlopeScale = depthBiasSlopeScale !== null && depthBiasSlopeScale !== void 0 ? depthBiasSlopeScale : RenderState.Default.depthBiasSlopeScale;
            let depthBiasClamp = datas[Shader3D.DEPTH_BIAS_CLAMP];
            depthBiasClamp = depthBiasClamp !== null && depthBiasClamp !== void 0 ? depthBiasClamp : RenderState.Default.depthBiasClamp;
            engineRenderState.setDepthBiasFactor(depthBiasConstant, depthBiasSlopeScale, depthBiasClamp);
        }
        var blend = datas[Shader3D.BLEND];
        blend = blend !== null && blend !== void 0 ? blend : RenderState.Default.blend;
        switch (blend) {
            case RenderState.BLEND_ENABLE_ALL:
                var blendEquation = datas[Shader3D.BLEND_EQUATION];
                blendEquation = blendEquation !== null && blendEquation !== void 0 ? blendEquation : RenderState.Default.blendEquation;
                var srcBlend = datas[Shader3D.BLEND_SRC];
                srcBlend = srcBlend !== null && srcBlend !== void 0 ? srcBlend : RenderState.Default.srcBlend;
                var dstBlend = datas[Shader3D.BLEND_DST];
                dstBlend = dstBlend !== null && dstBlend !== void 0 ? dstBlend : RenderState.Default.dstBlend;
                engineRenderState.setBlend(true);
                engineRenderState.setBlendEquation(blendEquation);
                engineRenderState.setBlendFunc(srcBlend, dstBlend);
                break;
            case RenderState.BLEND_ENABLE_SEPERATE:
                var blendEquationRGB = datas[Shader3D.BLEND_EQUATION_RGB];
                blendEquationRGB = blendEquationRGB !== null && blendEquationRGB !== void 0 ? blendEquationRGB : RenderState.Default.blendEquationRGB;
                var blendEquationAlpha = datas[Shader3D.BLEND_EQUATION_ALPHA];
                blendEquationAlpha = blendEquationAlpha !== null && blendEquationAlpha !== void 0 ? blendEquationAlpha : RenderState.Default.blendEquationAlpha;
                var srcRGB = datas[Shader3D.BLEND_SRC_RGB];
                srcRGB = srcRGB !== null && srcRGB !== void 0 ? srcRGB : RenderState.Default.srcBlendRGB;
                var dstRGB = datas[Shader3D.BLEND_DST_RGB];
                dstRGB = dstRGB !== null && dstRGB !== void 0 ? dstRGB : RenderState.Default.dstBlendRGB;
                var srcAlpha = datas[Shader3D.BLEND_SRC_ALPHA];
                srcAlpha = srcAlpha !== null && srcAlpha !== void 0 ? srcAlpha : RenderState.Default.srcBlendAlpha;
                var dstAlpha = datas[Shader3D.BLEND_DST_ALPHA];
                dstAlpha = dstAlpha !== null && dstAlpha !== void 0 ? dstAlpha : RenderState.Default.dstBlendAlpha;
                engineRenderState.setBlend(true);
                engineRenderState.setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha);
                engineRenderState.setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                break;
            case RenderState.BLEND_DISABLE:
            default:
                engineRenderState.setBlend(false);
                break;
        }
    }
    uploadRenderStateFrontFace(shaderDatas, isTarget, invertFront) {
        var _a;
        const engineRenderState = WebGLEngine.instance._GLRenderState;
        var renderState = (this._shaderPass).renderState;
        var datas = shaderDatas.getData();
        var cull = datas[Shader3D.CULL];
        if ((this._shaderPass).statefirst) {
            cull = (_a = renderState.cull) !== null && _a !== void 0 ? _a : cull;
        }
        cull = cull !== null && cull !== void 0 ? cull : RenderState.Default.cull;
        var forntFace;
        switch (cull) {
            case RenderState.CULL_NONE:
                engineRenderState.setCullFace(false);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                engineRenderState.setFrontFace(forntFace);
                break;
            case RenderState.CULL_FRONT:
                engineRenderState.setCullFace(true);
                if (isTarget == invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                engineRenderState.setFrontFace(forntFace);
                break;
            case RenderState.CULL_BACK:
            default:
                engineRenderState.setCullFace(true);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                engineRenderState.setFrontFace(forntFace);
                break;
        }
    }
}
